export const deleteAppPage = (payload: { id: number, mode?: string }) => ({
    type: "@saga/DELETE_APP_PAGE",
    payload
});